import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const PLANS = [
  {
    id: 'p1',
    name: '1 Frasco',
    badge: null,
    treatment: 'Até 1 mês de tratamento',
    installment: 'R$ 12,75',
    extra: 'R$ 127,00 à vista',
    image: IMAGE_PATHS.frasco1,
    alt: '1 frasco de Magrisim',
    href: 'https://pay.magrisim.com.br/checkout?product=1-frasco-fd8b',
    featured: false
  },
  {
    id: 'p2',
    name: '2 Frascos + 1 Grátis',
    badge: 'Mais comprado',
    treatment: 'Até 3 meses de tratamento',
    installment: 'R$ 25,50',
    extra: 'Economia de R$ 127,00',
    image: IMAGE_PATHS.frasco3,
    alt: '2 frascos + 1 grátis de Magrisim',
    href: 'https://pay.magrisim.com.br/checkout?product=2-frascos-1-gratis-c18e',
    featured: true
  },
  {
    id: 'p3',
    name: '3 Frascos + 2 Grátis',
    badge: 'Melhor oferta',
    treatment: 'Até 5 meses de tratamento',
    installment: 'R$ 38,05',
    extra: 'Economia de R$ 256,00',
    image: IMAGE_PATHS.frasco5,
    alt: '3 frascos + 2 grátis de Magrisim',
    href: 'https://pay.magrisim.com.br/checkout?product=3-frascos-2-gratis-3f6d',
    featured: false
  }
];

const OfferSection = () => {
  return (
    <section id="offer" className="mgs-offer">
      <div className="mgs-offer__inner">
        <h2 className="mgs-offer__title">
          Escolha o seu <span className="mgs-offer__title-gold">kit de emagrecimento</span> e
          ganhe frascos grátis.
        </h2>
        <p className="mgs-offer__subtitle">
          É recomendado de 3 a 5 frascos para melhores resultados!
        </p>

        <div className="mgs-offer__grid">
          {PLANS.map((plan) => (
            <article
              key={plan.id}
              className={`mgs-offer__card${plan.featured ? ' mgs-offer__card--featured' : ''}`}
            >
              {plan.badge && (
                <span className="mgs-offer__badge">{plan.badge}</span>
              )}

              <div className="mgs-offer__photo">
                <img src={plan.image} alt={plan.alt} />
              </div>

              <h3 className="mgs-offer__name">{plan.name}</h3>
              <span className="mgs-offer__treatment">{plan.treatment}</span>

              <div className="mgs-offer__price">
                <span className="mgs-offer__price-x">12x de</span>
                <span className="mgs-offer__price-value">{plan.installment}</span>
              </div>
              <span className="mgs-offer__extra">{plan.extra}</span>

              <a
                href={plan.href}
                target="_blank"
                rel="noopener noreferrer"
                className="mgs-offer__cta"
              >
                <i className="fas fa-shopping-cart"></i>
                COMPRAR AGORA
              </a>
            </article>
          ))}
        </div>

        <div className="mgs-offer__urgency">
          <p className="mgs-offer__urgency-lead">
            Enquanto você pensa, outras pessoas já estão no segundo frasco.
          </p>
          <p className="mgs-offer__urgency-cta">Adquira o seu antes que acabe!</p>
          <p className="mgs-offer__urgency-note">
            Estoque limitado. Condição disponível por pouco tempo.
          </p>
        </div>

        <div className="mgs-offer__trust">
          <img
            src={`${process.env.PUBLIC_URL}/images/selosseguros.png`}
            alt="Compra 100% segura · Pagamento seguro · Site protegido SSL · Regularizado pela Anvisa"
            className="mgs-offer__trust-img"
          />
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
